import React from 'react'; 
import WithConsumer from '../context/WithConsumer';
import GravityForm from "react-gravity-form";
import FadeIn from "react-lazyload-fadein";
import { Parallax } from 'react-scroll-parallax';
import  { Redirect } from 'react-router-dom'
import Foot from './Foot';

const Register = ({ context }) => {
		 
    const posts = () => context.posts;
    const post = posts()[0];
        
    const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    const ctxDoRender = () => context.doRender;
	const doRender = ctxDoRender();
		
    let pageClass = 'c-page-wrapper state-not-loaded';
    if (pageLoaded === true) {
	    pageClass = 'c-page-wrapper state-loaded';
    }
    
    function toggleLogin(evt) {
		evt.preventDefault();
		context.toggleLogin();
	}
    
    if (post && doRender) {
	    
	    if (post.form) {
    	
	    	return (
		    	<div className={pageClass}>
		    	
		    		{post.header_srcset &&
			    		<div className="c-header-image">
			    			<Parallax className="c-header-image__background" y={[-10, 10]} tagOuter="div">
				    			<FadeIn duration={250}>
									{onload => (
										<img
											alt={""}
											src={post.header_src} 
											srcSet={post.header_srcset} 
											onLoad={onload}
										/>
									)}
								</FadeIn>
							</Parallax>
			    		</div>
		    		}
		    		
		    		<div className="l-block l-block--max-width">
		        	
			        	<div className="l-grid l-grid--large-gutter">
				        	<div className="l-grid__col l-grid__col--m-7-12 l-grid__col--l-6-12">
				        		{post.heading &&
					        		<header className="c-content-block">
					        			<h1 className="c-heading">{ post.heading }</h1>
					        		</header>
				        		}
				        		<div className="scope-form scope-form--registration">
				        			<GravityForm
										backendUrl={document.location.origin + '/wp-json/bloomingdales/v1/form'}
										formID={post.form}
										populatedFields={{
										}}
									/>
								</div>
							</div>
							<div className="l-grid__col l-grid__col--m-5-12 l-grid__col--l-6-12">
								<div className="c-content-block scope-text-account">
									{post.about &&
										<div dangerouslySetInnerHTML={ {__html: post.about} }></div>
									}
									<hr /><p>Already a registered customer<br /><a href="#" onClick={toggleLogin}>Login here</a></p><hr />
									{post.help &&
										<div dangerouslySetInnerHTML={ {__html: post.help} }></div>
									}
								</div>
							</div>
						</div>
		    		
					</div>
					
					<Foot></Foot>
					
				</div>
	    	)
	    	
	    } else {
			return null
		}
    	
	} else {
		return null
	}
};
export default WithConsumer(Register);